import React, { useEffect, useState } from "react";
import PageHeader from "../../components/ui/PageHeader";
import SearchComp from "../../utils/search-comp";
import DescComp from "../../components/desc/DescComp";
import choose from "../../assets/choose.png";
import ListHouses from "../../components/ui/ListHouses";
import { AxiosGet } from "../../api/api";
import Loading from "../../components/ui/Loading";
import { optionsPrice, propCat, state } from "../../utils/ExportObjects";
import { Btn } from "../../utils/utils";
import HouseCard from "../../components/ui/HouseCard";
import "../../components/featured/featured.css";
import { useNavigate } from "react-router-dom";

const Residential = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [resData, setResData] = useState([]);
  const [pagData, setPagData] = useState();
  const [curPage, setCurPage] = useState(1);
  const [
    // propType,
    setPropType,
  ] = useState("");
  const [propLoc, setPropLoc] = useState("");
  const [propPrice, setPropPrice] = useState("");
  const btnArr = ["All", "For Sale", "For Rent"];
  const [active, setActive] = useState("All");
  const [activeTab, setActiveTab] = useState("All");

  const clickBtn = (item) => {
    setActiveTab(item);
    if (item === "All") {
      setActive(item);
    }
    if (item === "For Sale") {
      setActive("Sell");
    }
    if (item === "For Rent") {
      setActive("Rent");
    }
  };
  const url = `developers/properties/?propertyUse=${"Residential"}&priceRange=${propPrice}&page=${curPage}&location=${propLoc}&page_size=${12}`;

  const getRes = () => {
    setIsLoading(true);
    AxiosGet(url)
      .then((res) => {
        // console.log(res);
        setResData(res.data);
        setPagData(res.pagination);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.error(err.response);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getRes();
    // eslint-disable-next-line
  }, [curPage, propPrice, propLoc, active]);

  const clickNext = () => {
    setCurPage(pagData?.nextPage);
  };
  const clickPrev = () => {
    setCurPage(pagData?.previousPage);
  };

  const options = propCat;
  const optionsPriceArr = optionsPrice;
  //   const optionsType = [
  //     { value: "All", label: "All" },
  //     { value: "Sell", label: "Sell" },
  //     { value: "Rent", label: "Rent" },
  //   ];
  const optionsLoc = state;
  const viewProp = (item) => {
    localStorage.setItem('property', JSON.stringify(item));
    navigate(`/dev-view/${item?.id}`)
  };

  const handlePropChange = (value) => {
    setPropType(value);
  };
  const handleLocChange = (value) => {
    setPropLoc(value);
  };
  const handlePriceChange = (value) => {
    setPropPrice(value);
  };
  const reasonsArr = [
    {
      ques: "Expert Agents: ",
      ans: "Who guide you with unparalleled expertise.",
    },
    {
      ques: "Verified Listings: ",
      ans: "Ensuring only the highest quality properties.",
    },
    {
      ques: "Personalized Solutions: ",
      ans: "Tailored to meet your unique needs.",
    },
    {
      ques: "Market Insights: ",
      ans: "To help you make informed real estate decisions.",
    },
  ];
  return (
    <div>
      <PageHeader title={"Residential Properties"} text={"Home/ Residential"} />
      <SearchComp
        priceRange
        location
        handlePropertyChange={handlePropChange}
        handleLocChange={handleLocChange}
        handlePriceChange={handlePriceChange}
        options={options}
        optionsLoc={optionsLoc}
        optionsPrice={optionsPriceArr}
      />
      {btnArr && (
        <div className="list-type" style={{ width: "90%", margin: "40px auto 0" }}>
          {btnArr.map((item, i) => {
            return (
              <Btn
                btnClass={
                  activeTab === item ? "home-btn_s" : "home-btn_trans-s"
                }
                btnClick={() => clickBtn(item)}
                btnText={item}
                key={i}
              />
            );
          })}
        </div>
      )}
      {isLoading && <Loading />}
      <div className="featured-cards_cont">
        {!isLoading &&
          resData?.map((item, i) => {
            return (
              <HouseCard
                key={i}
                tag={item?.isVerified}
                price={`#${item?.pricePerUnit?.toLocaleString()}`}
                add={item.address}
                // bath={item.bath}
                // bed={item.bed}
                propType={item?.propertyType}
                noOfUnits={item?.numberOfUnits}
                title={item?.name}
                btnClick={() => viewProp(item)}
                img={item?.pictures[0]?.link}
                houseStyle={{ width: "20%" }}
              />
            );
          })}
      </div>
      <DescComp
        title={"Why Choose Us?"}
        text={
          "We’re dedicated to delivering exceptional service and unmatched expertise in the real estate market. Our features are designed to provide a seamless and stress-free, and rewarding experience, whether you’re buying, selling, or investing in property."
        }
        image={choose}
        descArr={reasonsArr}
        descBg={"#080B24"}
      />
    </div>
  );
};

export default Residential;
